







import Vue from 'vue'
import { Component } from 'vue-property-decorator';

const TitleAreaProps = Vue.extend({
  props: {
    title: String,
    subtitle: String
  }
})

@Component
export default class TitleArea extends TitleAreaProps {
  get areaTitle(): string {
    return this.title;
  }
  get areaSubTitle(): string {
    return this.subtitle;
  }
}
